// @flow
import * as React from 'react';
import { Box, Icon } from 'gestalt';

type Props = {|
  errorMessage?: string,
  id: string,
  name?: string,
  onChange: ({ event: SyntheticInputEvent<>, value: string }) => void,
  options: Array<{|
    label: string,
    value: string,
  |}>,
  value?: ?string,
|};

type State = {
  focused: boolean,
  errorIsOpen: boolean,
  errorMessage?: string,
};

export default class NuxSelectList extends React.Component<Props, State> {
  static defaultProps = {
    options: [],
  };

  state = {
    focused: false,
    errorIsOpen: false,
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    if (props.errorMessage !== state.errorMessage) {
      return {
        errorIsOpen: !!props.errorMessage,
        errorMessage: props.errorMessage,
      };
    }

    return null;
  }

  select: ?HTMLSelectElement;

  handleOnChange = (event: SyntheticInputEvent<>) => {
    this.props.onChange({ event, value: event.target.value });
  };

  handleBlur = () => {
    if (this.props.errorMessage) {
      this.setState({ errorIsOpen: false });
    }
  };

  handleFocus = () => {
    if (this.props.errorMessage) {
      this.setState({ errorIsOpen: true });
    }
  };

  render() {
    const { id, name, options, value } = this.props;
    // We're not using Gestalt SelectList here because of design requirements for this experiment.
    return (
      <Box alignItems="center" display="flex" position="relative">
        <Box
          alignItems="center"
          color="white"
          position="absolute"
          right
          paddingY={2}
          dangerouslySetInlineStyle={{
            __style: {
              paddingRight: '31px',
              paddingLeft: '16px',
              marginRight: '1px',
              pointerEvents: 'none',
            },
          }}
        >
          <Icon icon="arrow-down" size={24} color={'darkGray'} accessibilityLabel="" />
        </Box>
        <select
          id={id}
          name={name}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onChange={this.handleOnChange}
          ref={(c) => {
            this.select = c;
          }}
          value={value}
          style={{
            backgroundColor: 'white',
            border: '1px solid #979797',
            borderRadius: 8,
            cursor: 'pointer',
            height: 68,
            fontSize: 20,
            paddingLeft: 32,
            width: '100%',
            WebkitAppearance: 'none',
            MozAppearance: 'none',
          }}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </Box>
    );
  }
}
